
import { ServiceBase } from "../../data/service";
import Cookies from "js-cookie";

class functionsService extends ServiceBase {
  getLoggerName(): string {
    return "functionsService";
  }

  getUserVouchers = async () => {
    const token = Cookies.get('token');
    const parsedToken = JSON.parse(token || '{}');
    const response = await this.http.get('/auth/user/data/', {
      headers: {
        Authorization: `Bearer ${parsedToken.token}`,
      },
    });
    return response.data;
  };

  getSomething = async () => {
    const response = await this.http.get('/surveys/');
    return response.data;
  };
}

export default new functionsService();
